module.exports = __webpack_public_path__ + "printing-return-label.f18256b5f96ccefbb247db3a892eefa8.svg";